<mat-checkbox [formControl]="control" [disabled]="disabled">
  {{ label }}
</mat-checkbox>
